/*
  LGND "Select A Size" gate.
  Forces a deliberate size choice before Add-to-Cart (the cheapest proven apparel CRO win).
  Design principle: FAIL-OPEN. The button is only ever gated when NO size is selected.
  The moment any size radio is checked (by the shopper OR by Dawn's re-render), the gate lifts.
  It deselects Dawn's server pre-selection exactly ONCE per section, then only mirrors state —
  so it can never strand the ATC, loop, or fight Dawn's sold-out logic.
*/
(function () {
  var deselected = {}; // section id -> we've cleared the initial pre-selection once
  var GATE_LABEL = 'Select A Size';

  // Neutralize the Shop Pay / dynamic-checkout express button while no size is chosen
  try {
    var st = document.createElement('style');
    st.textContent = '.product-form.lgnd-size-gated .shopify-payment-button{opacity:.45;pointer-events:none;filter:grayscale(1)}';
    document.head.appendChild(st);
  } catch (e) {}

  function sizeFieldset(scope) {
    var found = null;
    scope.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (lg && /\bsize\b/i.test(lg.textContent) && !/one size|^\s*os\s*$/i.test(lg.textContent)) found = fs;
    });
    return found;
  }

  function setLabel(btn, text) {
    if (!btn) return;
    var s = btn.querySelector('span') || btn;
    if (s.textContent.trim() !== text) s.textContent = text;
  }

  function buttons(section) {
    var list = [];
    var main = section.querySelector('product-form button[name="add"]');
    if (main) list.push(main);
    // sticky mobile ATC, if present (best-effort, may live outside the section)
    document.querySelectorAll('.lgnd-mobile-atc button[name="add"], lgnd-mobile-atc button[name="add"], .lgnd-mobile-atc button.product-form__submit').forEach(function (b) {
      if (list.indexOf(b) === -1) list.push(b);
    });
    return list;
  }

  function sync(section) {
    try {
      var vs = section.querySelector('variant-selects');
      if (!vs) return;
      var sid = vs.getAttribute('data-section') || vs.id || 'x';
      var fs = sizeFieldset(section);
      if (!fs) return; // no size option -> never gate
      var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (radios.length < 2) return; // single/one-size -> never gate

      var pf = section.querySelector('product-form');
      if (!pf) return;
      var vid = pf.querySelector('.product-variant-id');
      var btns = buttons(section);

      // one-time: clear Dawn's pre-selected size so the shopper must choose
      if (!deselected[sid]) {
        deselected[sid] = true;
        radios.forEach(function (r) { r.checked = false; });
      }

      var anyChecked = radios.some(function (r) { return r.checked; });

      if (!anyChecked) {
        // GATE ON
        pf.classList.add('lgnd-size-gated'); // also neutralizes the Shop Pay express button (CSS)
        if (vid) vid.setAttribute('disabled', 'disabled');
        btns.forEach(function (btn) {
          if (!btn.dataset.origLabel) {
            var s = btn.querySelector('span') || btn;
            btn.dataset.origLabel = s.textContent.trim() || 'Add to cart';
          }
          btn.setAttribute('disabled', 'disabled');
          btn.dataset.lgndGated = '1';
          setLabel(btn, GATE_LABEL);
        });
      } else {
        // A size is chosen -> lift OUR gate. Dawn owns the real availability/sold-out state.
        pf.classList.remove('lgnd-size-gated');
        if (vid) vid.removeAttribute('disabled');
        btns.forEach(function (btn) {
          if (btn.dataset.lgndGated) {
            btn.removeAttribute('disabled');
            setLabel(btn, btn.dataset.origLabel || 'Add to cart');
            delete btn.dataset.lgndGated;
          }
        });
      }
    } catch (e) { /* fail-open */ }
  }

  function syncAll() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      var sec = vs.closest('product-info') || vs.closest('.product') || vs.closest('section') || document;
      sync(sec);
    });
  }

  // Mark chosen the instant a shopper interacts (before Dawn's async re-render)
  document.addEventListener('change', function (e) {
    var fs = e.target.closest && e.target.closest('fieldset.product-form__input');
    if (fs && fs.querySelector('legend') && /\bsize\b/i.test(fs.querySelector('legend').textContent)) {
      syncAll();
    }
  }, true);

  // Debounced re-sync after Dawn swaps product-info HTML on variant change
  var raf = null;
  var mo = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; syncAll(); });
  });

  function boot() {
    syncAll();
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
